import React, { useState } from "react";
import { useSelector } from "react-redux";
import ProductManagement from "./ProductManagement";
import ProductQuantity from "./ProductQuantity";

const StoreMaster = () => {
  const { first_name, last_name } = useSelector((state) => state?.auth?.auth);


  const [selectedTab, setSelectedTab] = useState("Product Master");
  const AllTabs = ["Product Master", "Low Qty Product"];

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
              <h6 className="headertext">{first_name + ' ' + last_name}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="main">
                  <div className="heading-content-bg d-flex justify-content-center align-items-center">
                    <h5 className="mb-0 font-bold"> Store Master</h5>
                  </div>
                  <div className="container">
                    <div className="my-3 row">
                      <div className="col-lg-2 px-0">
                        {AllTabs.map((tab, index) => {
                          return (
                            <div key={index} className="mb-2">
                              <button
                                type="button"
                                className={
                                  selectedTab === tab
                                    ? "btn w-100 text-start add-btn-active"
                                    : "btn w-100 text-start add-btn-inactive"
                                }
                                onClick={() => setSelectedTab(tab)}
                              >
                                {tab}
                              </button>
                            </div>
                          );
                        })}
                      </div>
                      <div className="col-lg-10 px-0">
                        {selectedTab === "Product Master" && (
                          <ProductManagement />
                        )}
                        {selectedTab === "Low Qty Product" && (
                          <ProductQuantity />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StoreMaster;
